import React from 'react';
import { Form, Button } from '@blueprintnyc/bpnyc-common';
import Select from 'components/Select';
import EventGroupsPicker from '@/components/EventGroupsPicker';

const SocialWidgetOptions = props => {
	const {
		widgetToUpdate,
		handleChange,
		widgetProps,
		onUpdate,
		handlePropChange,
		event,
		handleGroupChange,
		targetKeys,
	} = props;

	return (
		<Form initialValues={widgetToUpdate.props} onChange={handleChange}>
			<div className="WidgetUpdateForm">
				<h4 className="admin-form-item-label">Select Display Type</h4>
				<Select
					data={[
						{ id: 'standard', name: 'Standard' },
						{ id: 'carousel', name: 'Carousel' },
					]}
					value={widgetProps && widgetProps.display ? [widgetProps.display] : ['standard']}
					onChange={v => handlePropChange('display')(v)}
					form={true}
				/>
				<Form.Item label="Hashtag" name="hashtag">
					<Form.Input />
				</Form.Item>
				<Form.Item label="Include Widget Headers?" name="include_headers">
					<Form.TwoOptionSelect />
				</Form.Item>
				<h4 className="admin-form-item-label">Group Permissions</h4>
				<div className="groups-picker">
					<EventGroupsPicker
						event={event}
						handleChange={handleGroupChange}
						targetKeys={targetKeys}
					/>
				</div>
			</div>
			<Button type="submit" style={{ marginTop: '15px' }} onClick={() => onUpdate(widgetProps)}>
				Submit
			</Button>
		</Form>
	);
};

export default SocialWidgetOptions;
